import React from 'react';
import './UpdateBanner.css';

interface UpdateBannerProps {
  onUpdate: () => void;
}

const UpdateBanner: React.FC<UpdateBannerProps> = ({ onUpdate }) => (
  <div className='update-banner'>
    <span className='update-banner__text'>🔄 Nouvelle version disponible</span>
    <button className='update-banner__btn' onClick={onUpdate}>
      Mettre à jour
    </button>
  </div>
);

export default UpdateBanner;
